import type React from 'react';
import { Component } from 'react';
import { FaTimes } from 'react-icons/fa';

import { ConfigContext } from '../context/ConfigContext';
import type { TextData } from '../types/ChatWindow';
import Avatar from './Avatar';
import TextMessage from './message/text/TextMessage';

type TProps = {
  onClose: (e: React.MouseEvent) => void;
};

// TODO: Possibly move this
const GreetingCloseButton: React.FC<TProps> = ({ onClose }) => (
  <div className='header-close-button'>
    <FaTimes onClick={(e) => onClose(e)} />
  </div>
);

class Greeting extends Component<
  {
    onButtonClick: (...args: any[]) => void;
    onClose: (...args: any[]) => void;
    onLaterClick: (...args: any[]) => void;
  },
  { hover: boolean }
> {
  static contextType = ConfigContext;
  context!: React.ContextType<typeof ConfigContext>;

  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  toggleHover = () => {
    const { hover } = this.state;
    this.setState({
      hover: !hover,
    });
  };

  getHeaderByType(onClose: (e: unknown) => void) {
    const {
      greeting: {
        title,
        subtitle,
        headerType,
        showCloseButton,
        avatarType,
        avatarPath,
      },
      scheme: {
        header: { headerColor },
        greeting: { subtitleColor, titleColor },
      },
    } = this.context;

    switch (headerType) {
      case 'slim': {
        const actualTitle = subtitle ? `${title} - ${subtitle}` : title;
        return (
          <div
            className='header-container slim'
            style={{ backgroundColor: headerColor }}>
            <div>
              <p className='header-title slim' style={{ color: titleColor }}>
                {actualTitle}
              </p>
            </div>
            {showCloseButton && <GreetingCloseButton onClose={onClose} />}
          </div>
        );
      }
      default: {
        return (
          <div
            className='header-container normal'
            style={{ backgroundColor: headerColor }}>
            {headerType === 'normal' && (
              <figure className={`header-avatar ${avatarType}`}>
                <img src={avatarPath} alt='' />
              </figure>
            )}

            <div>
              <h3 className='header-title' style={{ color: titleColor }}>
                {title}
              </h3>
              <h5 className='header-subtitle' style={{ color: subtitleColor }}>
                {subtitle}
              </h5>
            </div>
            {showCloseButton && <GreetingCloseButton onClose={onClose} />}
          </div>
        );
      }
    }
  }

  render() {
    const { onButtonClick, onLaterClick, onClose } = this.props;

    const {
      greeting: { message, messageIcon, buttonText, allowLaterButton },
      scheme: {
        greeting: { buttonColor, backgroundColor },
        message: {
          messageBubbleColor,
          messageBubbleTextColor,
          buttonHoverColor,
          buttonBackgroundColor,
        },
        message: messageScheme,
      },
    } = this.context;

    const { hover } = this.state;

    const messageData: TextData = {
      text: message || 'Chat with us',
    };
    return (
      <div className='greeting-container' style={{ backgroundColor }}>
        {this.getHeaderByType(onClose)}
        <div className='greeting-body-container'>
          <div
            className='greeting-message-container'
            style={{
              backgroundColor: messageBubbleColor,
              color: messageBubbleTextColor,
            }}>
            <TextMessage data={messageData} />
            <Avatar avatarImg={messageIcon} />
          </div>
        </div>
        <div className='greeting-button-container'>
          <button
            className='button-default'
            type='button'
            style={{ backgroundColor: buttonColor, borderColor: buttonColor }}
            onClick={(e) => onButtonClick(e)}>
            {buttonText}
          </button>
          {allowLaterButton && (
            <button
              type='button'
              className='button-outline'
              onMouseEnter={this.toggleHover}
              onMouseLeave={this.toggleHover}
              onClick={(e) => onLaterClick(e)}
              style={{
                color: hover ? buttonHoverColor : buttonColor,
                borderColor: hover ? buttonHoverColor : buttonColor,
                backgroundColor: buttonBackgroundColor,
              }}>
              Later
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default Greeting;
